export type UserRole =
  | "DivisionAdmin"
  | "Concierge"
  | "AppAdmin"
  | "Reports";

  export const isReportsUser = (roles: UserRole[]) => {
    return roles.length === 1 && roles[0] === "Reports";
  };

  export const isConciergeUser = (roles: UserRole[]): boolean => {
    return roles.some((role) => role === "Concierge");
  };
  
  export const isDivisionAdminUser = (roles: UserRole[]) => {
    return roles.some((role) => role === "DivisionAdmin");
  };

  export const isAppAdminUser = (roles: UserRole[]) => {
    return roles.some((role) => role === "AppAdmin");
  };
  
